module.exports = __webpack_public_path__ + "static/img/qq_img_2.c7728ec2.png";